/**
 * Deterministic PRNG. mulberry32 — 32-bit state, fast, good enough for gameplay.
 * All randomness in the game must route through here.
 */
let _state = 0;

export function seed(s) {
  _state = s >>> 0;
}

export function random() {
  let t = (_state += 0x6D2B79F5) >>> 0;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

export function randomBetween(min, max) {
  return min + random() * (max - min);
}

export function randomInt(min, max) {
  return Math.floor(randomBetween(min, max + 1));
}

export function pickWeighted(entries) {
  // entries: [[item, weight], ...]
  const total = entries.reduce((s, [, w]) => s + w, 0);
  let r = random() * total;
  for (const [item, w] of entries) {
    r -= w;
    if (r <= 0) return item;
  }
  return entries[entries.length - 1][0];
}

export function seedFromString(str) {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function seedFromDateISO(dateISO) {
  return seedFromString('arczero_' + dateISO);
}

export function dailyModifier(dateISO) {
  if (!dateISO) return 'standard';
  const dayMs = Date.parse(dateISO);
  if (isNaN(dayMs)) return 'standard';
  const dayIndex = Math.abs(Math.floor(dayMs / 86400000));
  const mods = ['standard', 'speedrun', 'noradar', 'precision'];
  return mods[dayIndex % 4];
}
